import React from "react";
import styled from "styled-components";


export default styled.div`
    width: 100%;
    margin: 0 auto;
    max-width: 100%;
    padding-top: 117px;    
`;
